import "./FigmaWikiHeader.scss"

import { Link, useSearchParams } from "react-router-dom"

import { UserRole } from "@/entities/user"
import Icon from "@/shared/components/intrinsic/Icon/Icon"
import { useAppSelector } from "@/store/hooks"

function FigmaWikiHeader() {
  const { user } = useAppSelector((state) => state)
  const [searchParams] = useSearchParams()
  const companyId = searchParams.get("companyId")
  const url = user.role >= UserRole.StreamManager ? `/companies${companyId ? `?company-id=${companyId}` : ""}` : `/companies/${companyId}`

  return (
    <div className="figma-wiki-layout__header">
      <Link className="figma-wiki-layout__link" to={url}>
        <Icon name="chevron-left" />
        {user.role >= UserRole.StreamManager ? "Back to company selection" : "Back"}
      </Link>
    </div>
  )
}

export default FigmaWikiHeader
